module.exports = __webpack_public_path__ + "img/project_winter_screenshot_4.f240e7cb.png";